import { render, staticRenderFns } from "./MessagesListRender.vue?vue&type=template&id=dbb08582"
import script from "./MessagesListRender.vue?vue&type=script&lang=js"
export * from "./MessagesListRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports